import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OpenMessageUpdateLog } from '../models/open-message/open-message-update-log.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class OpenMessageUpdateLogService extends RequestService<OpenMessageUpdateLog> {
  static PATH = '/open/message/update/log';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(httpClient, OpenMessageUpdateLogService.PATH, globalService.debugUrl);
  }
}
